import styled from "styled-components/macro"
import { size } from "../../../../utils/breakpoints"

export const CalendarWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
`

export const DropdownContainer = styled.ul`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  width: 90%;

  padding: 0.5rem;
  cursor: pointer;
  flex-wrap: wrap;

  position: absolute;
  left: 50;
  background-color: #434368;

  @media ${size.lg} {
    max-width: 600px;
  }
`

export const Container = styled.div`
  /* position: absolute; */
  /* @media ${size.lg} {
    margin-bottom: ${({ margin }) => (margin ? `${margin}px` : "80px")};
  } */
`

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const DropdownItem = styled.li`
  padding-right: 0.8rem;
  position: relative;
  color: ${({ highlight }) =>
    highlight ? "var(--highlightColor)" : "var(--textColor)"};

  font-size: 20px;
  transition: all 0.2s ease-in-out;
  text-transform: initial;

  :hover {
    color: var(--highlightColor);
  }

  :after {
    position: absolute;
    content: "";
    right: 0.4rem;
    top: 15%;
    height: 70%;
    width: 1px;
    background-color: white;
  }
`
